import {CardStack} from "@/components/CardStack/CardStack.tsx";
import {CheckAlertsListResponse, LatestDowntime} from "@/lib/queries/checks.ts";
import {StatHeaderAlerts} from "@/pages/checks/analysis/statsHeader/StatHeaderAlerts.tsx";
import {StatHeaderCheckFrequency} from "@/pages/checks/analysis/statsHeader/StatHeaderCheckFrequency.tsx";
import {StatHeaderCurrentStatus} from "@/pages/checks/analysis/statsHeader/StatHeaderCurrentStatus.tsx";
import {StatHeaderDowntime} from "@/pages/checks/analysis/statsHeader/StatHeaderDowntime.tsx";
import {StatHeaderLastDowntime} from "@/pages/checks/analysis/statsHeader/StatHeaderLastDowntime.tsx";
import {StatHeaderUptime} from "@/pages/checks/analysis/statsHeader/StatHeaderUptime.tsx";
import {getCheckState} from "@/pages/checks/analysis/statsHeader/utils.ts";

interface StatsHeaderProps {
  alerts: CheckAlertsListResponse;
  createdAt: string;
  downtimeSecs: number;
  interval: number;
  isPaused: boolean;
  isUnderMaintenance: boolean;
  isUp: boolean;
  lastDownAlertAt?: Date;
  latestDowntime?: LatestDowntime;
  outages: number;
  supportsDowntime?: boolean;
  uptime?: number;
  uptimeSLA: number;
}

export const StatsHeader = ({
  alerts,
  createdAt,
  downtimeSecs,
  interval,
  isPaused,
  isUnderMaintenance,
  isUp,
  latestDowntime,
  outages,
  supportsDowntime,
  uptime,
  uptimeSLA,
}: StatsHeaderProps) => {
  return (
    <CardStack columns={supportsDowntime ? {sm: 1, md: 2, lg: 3, xl: 3} : undefined}>
      <StatHeaderCurrentStatus
        state={getCheckState({state_is_up: isUp, is_paused: isPaused, created_at: createdAt})}
        createdAt={createdAt}
        isUnderMaintenance={isUnderMaintenance}
      />

      <StatHeaderUptime uptime={uptime || 0} createdAt={createdAt} uptimeSLA={uptimeSLA} />

      <StatHeaderCheckFrequency interval={interval} />
      {supportsDowntime && (
        <>
          <StatHeaderDowntime downtimeSecs={downtimeSecs} outages={outages} />

          <StatHeaderLastDowntime isUp={isUp} latestDowntime={latestDowntime} />

          <StatHeaderAlerts alerts={alerts} />
        </>
      )}
    </CardStack>
  );
};
